import React, { MouseEventHandler } from 'react'

import styles from './styles.module.css'

const CloseButton = ({ onClick, className }: { onClick: MouseEventHandler<HTMLButtonElement>; className?: string }) => (
  <button className={`${styles.closeButton} ${className}`} onClick={onClick}>
    <svg className={styles.closeIcon} width='12px' height='12px' viewBox='0 0 12 12'>
      <use xlinkHref='/icons.svg#icon-cross' />
    </svg>
  </button>
)

export default CloseButton
